import React from 'react';

/**
 * Minimal, dependency-free markdown renderer for chat bubbles. The bot answers
 * come back with markdown (bold, lists, code) that looked like raw asterisks in
 * the preview. Full HTML is escaped FIRST, then a small whitelist of our own
 * tags is generated — nothing from the source string is ever emitted as HTML.
 */
function escapeHtml(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function inline(s: string): string {
  return s
    .replace(/`([^`]+)`/g, '<code>$1</code>')
    .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
    .replace(/\*([^*]+)\*/g, '<em>$1</em>');
}

export function renderMarkdownLite(text: string): string {
  const lines = escapeHtml(text).split('\n');
  const out: string[] = [];
  let inList = false;
  for (const line of lines) {
    const li = line.match(/^\s*[-・]\s+(.*)$/);
    if (li) {
      if (!inList) { out.push('<ul>'); inList = true; }
      out.push(`<li>${inline(li[1])}</li>`);
      continue;
    }
    if (inList) { out.push('</ul>'); inList = false; }
    const h = line.match(/^(#{1,4})\s+(.*)$/);
    if (h) { out.push(`<div class="md-h">${inline(h[2])}</div>`); continue; }
    out.push(line.trim() === '' ? '<div class="md-gap"></div>' : `<div>${inline(line)}</div>`);
  }
  if (inList) out.push('</ul>');
  return out.join('');
}

const Markdown: React.FC<{ text: string }> = ({ text }) => (
  // Safe: the source is fully HTML-escaped before our whitelist tags are added.
  <div className="md" dangerouslySetInnerHTML={{ __html: renderMarkdownLite(text) }} />
);

export default Markdown;
